import { render, staticRenderFns } from "./TabProfile.vue?vue&type=template&id=44586010&scoped=true&"
import script from "./TabProfile.vue?vue&type=script&lang=js&"
export * from "./TabProfile.vue?vue&type=script&lang=js&"
import style0 from "./TabProfile.vue?vue&type=style&index=0&id=44586010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44586010",
  null
  
)

export default component.exports